// TODO: difficult to maintain => to be splitted and typed
import { downloadCSV, Exporter, RaRecord } from 'react-admin'
import jsonExport from 'jsonexport/dist'
import ENTITIES, { EntityDescriptor } from './entities/index'
import { isDefined } from 'services/utils'
import { handleFunction } from 'services/utils/functionHandling'
import { APIEntity } from 'services/api/entities'
import { WithId } from 'types/common'
import { KampaayDataProvider } from 'services/api/dataProvider'

// override Exporter parameter by specializing entity as APIEntity
type KExporterParameters = Parameters<Exporter>
type KExporterDATA = KExporterParameters[0]
type KExporterFETCH = KExporterParameters[1]
export type KExporter = (
  data: KExporterDATA,
  fetchRelatedRecords: KExporterFETCH,
  dataProvider: KampaayDataProvider,
  entity: APIEntity
) => void

type ExportRecordProps = {
  resource?: APIEntity
  record?: RaRecord
}

const exportJson = (
  data: any[],
  entity: APIEntity,
  entityObject: EntityDescriptor<any>
) => {
  return jsonExport(data, { headers: entityObject.headers }, (err, csv) => {
    if (err) console.log('ERROR EXPORTING JSON DATA: ', err)
    downloadCSV(csv, entity)
  })
}

// Export a single record from edit/show view
export const exportRecord = (props: ExportRecordProps) => {
  if (!props.resource) throw new Error('No resource found')
  const entityObject = isEntity(props.resource)
  if (!entityObject || !entityObject.format)
    throw new Error('No entity object found')
  const data = [entityObject.format()(props.record)]
  exportJson(data, props.resource, entityObject)
}

const isEntity = (resource: APIEntity) => {
  if (ENTITIES[resource]) return ENTITIES[resource]
  else throw new Error()
}

const exportFormatter = (isBulk = false): KExporter => async (
  records: WithId[],
  fetchRelatedRecords,
  dataProvider,
  entity
) => {
  if (!entity) throw new Error('No entity found')
  const entityObject = isEntity(entity)
  if (!entityObject || !entityObject.format)
    throw new Error('No entity object found')
  // fetchRelatedRecords calls dataProvider.getMany passing it the entity and the array of ids from the records as "ids" in the params object
  // and returns an object which is a record of the items ids and the full records
  const relatedRecords = !isBulk
    ? await fetchRelatedRecords(records, 'id', entity)
    : null

  const formattedData = await Promise.all(
    (!isBulk
      ? records.map((r) => relatedRecords[r.id]).filter(isDefined)
      : records
    ).map(handleFunction(entityObject.format(dataProvider)))
  )

  exportJson(formattedData, entity, entityObject)
}

export default exportFormatter
